import { Card } from '@/components/ui/card';
import { Clock, Car } from 'lucide-react';

export const SummaryCard = ({ duration, distance }) => {
  const formatDuration = (seconds) => {
    if (!seconds) return '--';
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }
    return `${minutes} min`;
  };

  const formatDistance = (meters) => {
    if (!meters) return '--';
    const miles = meters * 0.000621371;
    return `${miles.toFixed(1)} mi`;
  };

  return (
    <Card className="p-4 bg-white dark:bg-zinc-900 border-border shadow-[0_2px_8px_rgba(0,0,0,0.08)]" data-testid="summary-card">
      <div className="grid grid-cols-2 gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-[#2563EB]/10 flex items-center justify-center">
            <Clock className="w-5 h-5 text-[#2563EB]" />
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Total Time</p>
            <p className="text-xl font-heading font-bold text-foreground" data-testid="total-duration">
              {formatDuration(duration)}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-[#FF3B30]/10 flex items-center justify-center">
            <Car className="w-5 h-5 text-[#FF3B30]" />
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Total Distance</p>
            <p className="text-xl font-heading font-bold text-foreground" data-testid="total-distance">
              {formatDistance(distance)}
            </p>
          </div>
        </div>
      </div>
    </Card>
  );
};
